import { put } from 'redux-saga/effects'
import { IPcr } from '../../../../pcr/store/pcr.types'
import { getSelectedDataFromObject } from '../../../../../utilities/data.util'
import { initialPupilsState } from '../store/pupils.reducers'
import { setPupils } from '../store/pupils.actions'

export function* getPupils(pcrDoc: IPcr) {
  if (pcrDoc && pcrDoc.prNabc) {
    const prNabc = pcrDoc.prNabc
    const pupilsItems = getSelectedDataFromObject(prNabc, Object.keys(initialPupilsState))
    const pupils = {
      ...pupilsItems,
    }
    if (pupils && Object.keys(pupils).length !== 0) {
      yield put(setPupils(pupils))
    }
  }
}
